import { createFileRoute } from '@tanstack/react-router'
import { Walkdowns } from 'pages/walkdown/Walkdowns'

export const Route = createFileRoute('/walkdowns/$siteID/')({
  component: Walkdowns,
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})
